import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FileSpreadsheet = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M20.413 19L21.701 17.712C21.876 17.537 21.989 17.287 21.989 17C21.989 16.45 21.539 16 20.989 16C20.714 16 20.464 16.113 20.277 16.288L19.002 17.588L17.714 16.3C17.539 16.125 17.289 16.012 17.002 16.012C16.452 16.012 16.002 16.462 16.002 17.012C16.002 17.287 16.115 17.537 16.29 17.724L17.578 19.012L16.29 20.3C16.115 20.475 16.002 20.725 16.002 21.012C16.002 21.562 16.452 22.012 17.002 22.012C17.277 22.012 17.527 21.899 17.714 21.724L19.002 20.436L20.29 21.724C20.465 21.899 20.715 22.012 21.002 22.012C21.552 22.012 22.002 21.562 22.002 21.012C22.002 20.737 21.889 20.487 21.714 20.3L20.414 19H20.413Z" />
		<path d="M23 4H9C6.237 4 4 6.237 4 9V23C4 25.762 6.237 28 9 28H23C25.762 28 28 25.762 28 23V9C28 6.237 25.762 4 23 4ZM26 9V10H12V6H23C24.65 6 26 7.35 26 9ZM9 6H10V10H6V9C6 7.35 7.35 6 9 6ZM6 23V12H10V26H9C7.35 26 6 24.65 6 23ZM23 26H12V12H26V23C26 24.65 24.65 26 23 26Z" />
	</svg>
);

export default FileSpreadsheet;
